var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActions,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerPage,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("board", {
        staticClass: "my-3",
        attrs: { details: _vm.board },
        scopedSlots: _vm._u([
          {
            key: "data-item",
            fn: function({ item }) {
              return [
                item.status
                  ? _c(
                      "div",
                      [
                        _c("custom-balloon", {
                          attrs: {
                            "background-color": item.status.color,
                            dot: "",
                            text: item.status.name
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c("rundown", { staticClass: "my-3", attrs: { value: _vm.value } }),
      _c("filter-manager", {
        staticClass: "my-3",
        attrs: { "display-advanced": false, filters: _vm.filters },
        on: {
          search: function($event) {
            return _vm.search()
          }
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _c("custom-separator", {
        staticClass: "my-3",
        attrs: { text: "Servicios" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            staticClass: "my-3",
            attrs: { text: "No hay información disponible." }
          })
        : _c(
            "div",
            [
              _vm._l(_vm.results, function(item) {
                return _c("result-row", {
                  key: item.id,
                  staticClass: "my-3",
                  attrs: { value: item }
                })
              }),
              _vm.showPagination
                ? _c("pagination", {
                    attrs: { data: _vm.pagination, "show-text": "" },
                    on: { "pagination-go-page": _vm.search }
                  })
                : _vm._e()
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }